<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getControlCardLogs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="ControlCard" id="filter-" size="sm" :model.sync="filter.controlCardId" @input="getControlCards" @focus="getControlCards" />
					<app-input-textbox id="fieldset-transaction-type" label-cols-sm="4" label-cols-lg="3" label="Transaction Type" label-for="filter-transaction-type" size="sm" :model.sync="filter.transactionType" />
					<app-input-textbox id="fieldset-transaction" label-cols-sm="4" label-cols-lg="3" label="TransactionId" label-for="filter-transaction" size="sm" :model.sync="filter.transaction" />
					<app-input-textbox id="fieldset-qty-before" label-cols-sm="4" label-cols-lg="3" label="Qty Before" label-for="filter-qty-before" size="sm" :model.sync="filter.qtyBefore" />
					<app-input-textbox id="fieldset-qty-after" label-cols-sm="4" label-cols-lg="3" label="Qty After" label-for="filter-qty-after" size="sm" :model.sync="filter.qtyAfter" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area Before" id="filter-" size="sm" :model.sync="filter.areaBeforeId" @input="getAreas" @focus="getAreas" />
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Area After" id="filter-" size="sm" :model.sync="filter.areaAfterId" @input="getAreas" @focus="getAreas" />
					<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Rack Before" id="filter-" size="sm" :model.sync="filter.rackBeforeId" @input="getRacks" @focus="getRacks" />
					<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Rack After" id="filter-" size="sm" :model.sync="filter.rackAfterId" @input="getRacks" @focus="getRacks" />
					<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card Status" id="filter-" size="sm" :model.sync="filter.controlCardStatusId" @input="getControlCardStatuss" @focus="getControlCardStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getControlCardLogs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Control Card Log</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" v-if="false" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/controlcardlog/ControlCardLog.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button v-if="false" class="btn-create btn-fill-success" to="/controlcardlog/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button v-if="false" class="btn-create btn-fill-success" to="/controlcardlog/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button v-if="false" class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-controlcardlog" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="controlCardLogs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="controlCardLogs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="ControlCard" class="table-filter">
					<v-select append-to-body label="controlCardNumber" :options="controlCards" :value="filter.controlCardId" :reduce="item => item.id" v-model="filter.controlCardId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getControlCards"></v-select>
				</b-th>
				<b-th stacked-heading="Transaction Type" class="table-filter">
					<b-form-input id="input-transaction-type-table" @input="getControlCardLogsWithoutLoading" v-model="filter.transactionType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="TransactionId" class="table-filter">
					<b-form-input id="input-transaction-table" @input="getControlCardLogsWithoutLoading" v-model="filter.transaction" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Before" class="table-filter">
					<b-form-input id="input-qty-before-table" @input="getControlCardLogsWithoutLoading" v-model="filter.qtyBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After" class="table-filter">
					<b-form-input id="input-qty-after-table" @input="getControlCardLogsWithoutLoading" v-model="filter.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Area Before" class="table-filter">
					<v-select append-to-body label="code" :options="areas" :value="filter.areaBeforeId" :reduce="item => item.id" v-model="filter.areaBeforeId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getAreas"></v-select>
				</b-th>
				<b-th stacked-heading="Area After" class="table-filter">
					<v-select append-to-body label="code" :options="areas" :value="filter.areaAfterId" :reduce="item => item.id" v-model="filter.areaAfterId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getAreas"></v-select>
				</b-th>
				<b-th stacked-heading="Rack Before" class="table-filter">
					<v-select append-to-body label="code" :options="racks" :value="filter.rackBeforeId" :reduce="item => item.id" v-model="filter.rackBeforeId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getRacks"></v-select>
				</b-th>
				<b-th stacked-heading="Rack After" class="table-filter">
					<v-select append-to-body label="code" :options="racks" :value="filter.rackAfterId" :reduce="item => item.id" v-model="filter.rackAfterId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getRacks"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card Status" class="table-filter">
					<v-select append-to-body label="name" :options="controlCardStatuss" :value="filter.controlCardStatusId" :reduce="item => item.id" v-model="filter.controlCardStatusId" :filterable="true" @input="getControlCardLogsWithoutLoading" @search="getControlCardStatuss"></v-select>
				</b-th>

						<b-th stacked-heading="Select All">
							<!-- <b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox> -->
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(controlcard)="row">
						<a @click="() => ( $router.push({ name: 'controlcardlogdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.controlCard.controlCardNumber != null && row.item.controlCard.controlCardNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.controlCard.controlCardNumber.slice(0, 30) + (row.item.controlCard.controlCardNumber.length > 30 ? "..." : "" ) : row.item.controlCard.controlCardNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(areaBefore)="row">
				{{ row.item.areaBefore != null ? row.item.areaBefore.code : "" }}
			</template>
			<template v-slot:cell(areaAfter)="row">
				{{ row.item.areaAfter != null ? row.item.areaAfter.code : "" }}
			</template>
			<template v-slot:cell(rackBefore)="row">
				{{ row.item.rackBefore != null ? row.item.rackBefore.code : "" }}
			</template>
			<template v-slot:cell(rackAfter)="row">
				{{ row.item.rackAfter != null ? row.item.rackAfter.code : "" }}
			</template>
			<template v-slot:cell(controlCardStatus)="row">
				{{ row.item.controlCardStatus != null ? row.item.controlCardStatus.name : "" }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<!-- <b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox> -->
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-transaction" label-cols-lg="12"  label="TransactionId" label-for="input-transaction" size="sm" :model.sync="row.item.transaction"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="row.item.qtyBefore"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="row.item.qtyAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.areaBeforeId" label="Area Before" :selected="row.item.areaBefore != null ? row.item.areaBefore.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.areaAfterId" label="Area After" :selected="row.item.areaAfter != null ? row.item.areaAfter.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.rackBeforeId" label="Rack Before" :selected="row.item.rackBefore != null ? row.item.rackBefore.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.rackAfterId" label="Rack After" :selected="row.item.rackAfter != null ? row.item.rackAfter.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.controlCardStatusId" label="Control Card Status" :selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(controlCardLogsPaging != null ? controlCardLogsPaging.dataCount : 0)"
									:per-page="(controlCardLogsPaging != null ? controlCardLogsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-controlcardlog.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-controlcardlog.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ControlCardLog from '@/models/ControlCardLog/ControlCardLog';
import ControlCardLogList from '@/models/ControlCardLog/ControlCardLogList';
import ControlCardLogFilter from '@/filters/ControlCardLog/ControlCardLogFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import AppInputTextbox from '@/components/AppInputTextbox';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import RackFilter from '@/filters/Rack/RackFilter';
import Rack from '@/models/Rack/Rack';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		ControlCardLog, 
		ControlCardLogList, 
		ControlCardLogFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"controlCard": {}, "class" : "th-control-card first-child", "label" : "ControlCard", key: 'controlCard', sortable: true}, 
				{"transactionType": {}, "class" : "th-transaction-type", "label" : "Transaction Type", key: 'transactionType', sortable: true}, 
				{"transaction": {}, "class" : "th-transaction last-child", "label" : "TransactionId", key: 'transaction', sortable: true}, 
				{"qtyBefore": {}, "class" : "th-qty-before d-stack-none", "label" : "Qty Before", key: 'qtyBefore', sortable: true}, 
				{"qtyAfter": {}, "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', sortable: true}, 
				{"areaBefore": {}, "class" : "th-area-before d-stack-none", "label" : "Area Before", key: 'areaBefore', sortable: true}, 
				{"areaAfter": {}, "class" : "th-area-after d-stack-none", "label" : "Area After", key: 'areaAfter', sortable: true}, 
				{"rackBefore": {}, "class" : "th-rack-before d-stack-none", "label" : "Rack Before", key: 'rackBefore', sortable: true}, 
				{"rackAfter": {}, "class" : "th-rack-after d-stack-none", "label" : "Rack After", key: 'rackAfter', sortable: true}, 
				{"controlCardStatus": {}, "class" : "th-control-card-status d-stack-none", "label" : "Control Card Status", key: 'controlCardStatus', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			controlCardLogs: [],
			controlCardLogsPaging: {},
			controlCards : [],
			areas : [],
			racks : [],
			controlCardStatuss : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getControlCardLogs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ControlCardLog.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.controlCardLogs = result.data
					this.controlCardLogsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getControlCardLogsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ControlCardLog.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.controlCardLogs = result.data
					this.controlCardLogsPaging = result
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ControlCardLogFilter();
			this.getControlCardLogs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getControlCardLogs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ControlCardLog.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ControlCardLog.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ControlCardLog.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ControlCardLog.deleteData(this, id).then(result => {
				if (result)
				{
					this.getControlCardLogs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ControlCardLog.deleteMultipleData(this).then(result => {
					this.getControlCardLogs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableControlCardLogParent = document.getElementById('table-list-controlcardlog').parentNode;
			tableControlCardLogParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableControlCardLogParent.scrollWidth - tableControlCardLogParent.offsetWidth) == Math.ceil(tableControlCardLogParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableControlCardLogParent = document.getElementById('table-list-controlcardlog').parentNode;
			tableControlCardLogParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableControlCardLogParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ControlCardLogFilter();
		// this.getControlCards()
		// this.getAreas()
		// this.getRacks()
		// this.getControlCardStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Control Card Log"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getControlCardLogs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getControlCardLogs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getControlCardLogs();
			}
		},
		currentPage: {
			handler: function() {
				this.getControlCardLogs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getControlCardLogs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ControlCardLog.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "controlcardlogindex") {
					this.getControlCardLogsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "control_card_log").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
